/**
 * Integrations Module Configuration
 *
 * Manages third-party integrations (Apollo.io, Acumatica, Smartsheet).
 * Supports integration registration, configuration, API key management,
 * and property sync operations.
 *
 * @see .context/WEB-APP.md for architecture documentation
 */

import type { AppModule } from '@/types/architecture'
import routes from './routes'

const integrationsModule: AppModule = {
    id: 'integrations',

    navigation: {
        label: 'Integrations',
        icon: 'plug',
        path: '/integrations',
        order: 30,
        moduleKey: 'settings.integrations',
        showInSidebar: false, // Accessed via Settings group


        pages: [
            {
                label: 'All Integrations',
                path: '/integrations',
            },
            {
                label: 'Bulk Sync',
                path: '/integrations/apollo/sync',
                icon: 'refresh-cw',
            },
        ],
    },

    routes,
}

export default integrationsModule
